import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    productoccupancyruleisLoading : false,
    productoccupancyrule: [],
    totalCurrency: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    productoccupancyruleiscLoading:false,
    productoccupancyruleCstatus:"",
    productoccupancyruleCMessage:"",
    productoccupancyruledetails:{},
    productoccupancyruleismloading:false,
    productoccupancyrulemstatus:"",
    productoccupancyrulemmessage:"",
    occupancyrules: {},
    productoccupancyruledstatus:"",
    productoccupancyruledmessage:"",
    error:"",
    
};


const productoccupancyruleSlice = createSlice({
    name: "occupancyruleList",
    initialState,
    reducers:{
        getProductOccupancyRulePending: (state) => {
            state.productoccupancyruleisLoading = true;
        },
        getProductOccupancyRuleSuccess: (state, { payload }) => {
            state.productoccupancyruleisLoading = false;
            state.productoccupancyrule = payload;
            state.productoccupancyruledetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getProductOccupancyRuleFail: (state, { payload }) => {
            state.productoccupancyruleisLoading = false;
            state.error = payload;
        },
        createProductOccupancyRulePending:(state,action) => {
            state.productoccupancyruleiscLoading=true;
        },
        createProductOccupancyRuleSuccess:(state,{payload}) => {
            state.productoccupancyruleiscLoading=false;
            state.productoccupancyruleCstatus="success";
            state.productoccupancyruleCMessage=payload;
        },
        createProductOccupancyRuleFail:(state,{payload}) => {
            state.productoccupancyruleiscLoading=false;
            state.productoccupancyruleCstatus="fail";
            //console.log('slice '+payload);
            state.productoccupancyruleCMessage=payload;
        },
        getSProductOccupancyRulePending: (state) => {
            state.productoccupancyruleisLoading = true;
        },
        getSProductOccupancyRuleSuccess: (state, { payload }) => {
            state.productoccupancyruleisLoading = false;
            state.occupancyrules=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSProductOccupancyRuleFail: (state, { payload }) => {
            state.productoccupancyruleisLoading = false;
            state.error = payload;
        },
        modifyProductOccupancyRulePending:(state,action) => {
            state.productoccupancyruleismloading=true;
            state.productoccupancyrulemstatus="";
        },
        modifyProductOccupancyRuleSuccess:(state,{payload}) => {
            state.productoccupancyruleismloading=false;
            state.productoccupancyrulemstatus="success";
           
            state.productoccupancyrulemmessage="ProductOccupancyRule Successfully Updated";
        },
        modifyProductOccupancyRuleFail:(state,{payload}) => {
            state.productoccupancyruleismloading=false;
            state.productoccupancyrulemstatus="fail";
           // console.log('slice '+payload);
            state.productoccupancyrulemmessage=payload;
        },
        deleteProductOccupancyRulePending:(state,action) => {
            state.productoccupancyruleisloading=true;
            state.productoccupancyruledstatus="";
        },
        deleteProductOccupancyRuleSuccess:(state,{payload}) => {
            state.productoccupancyruleisLoading=false;
            state.productoccupancyruledstatus="success";
            state.productoccupancyruledmessage="ProductOccupancyRule Successfully Deleted";
        },
        deleteProductOccupancyRuleFail:(state,{payload}) => {
            state.productoccupancyruleisLoading=false;
            state.productoccupancyruledstatus="fail";
           // console.log('slice '+payload);
            state.productoccupancyruledmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = productoccupancyruleSlice;

export const { getProductOccupancyRulePending, getProductOccupancyRuleSuccess, getProductOccupancyRuleFail,getSProductOccupancyRulePending, getSProductOccupancyRuleSuccess, getSProductOccupancyRuleFail, 
    createProductOccupancyRulePending, createProductOccupancyRuleSuccess, createProductOccupancyRuleFail,
    modifyProductOccupancyRulePending,modifyProductOccupancyRuleSuccess,modifyProductOccupancyRuleFail,
    deleteProductOccupancyRulePending,deleteProductOccupancyRuleSuccess,deleteProductOccupancyRuleFail  } = actions;

export default reducer;
